import { render } from "./OrderHistoryPage.vue?vue&type=template&id=07e0b4dd&scoped=true"
import script from "./OrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./OrderHistoryPage.vue?vue&type=script&lang=js"

import "./OrderHistoryPage.vue?vue&type=style&index=0&id=07e0b4dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e0b4dd"]])

export default __exports__